<template>
  <div class="w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-4">
    <vs-card
      id="review-order-donut-loading"
      class="vs-con-loading__container px-2 widget-card"
      style="position: relative"
    >
      <card-header :title="$t('widget_review_oder_by_status')"></card-header>
      <vs-row>
        <vs-col class="body-card-widget">
          <review-order-donut
            :chartId="'review-order-donut'"
            :height="'275'"
            :series="seriesDonut"
          />
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import ReviewOrderDonut from '@/views/modules/import_export/review_order/components/ReviewOrderDonut'
import reviewOrder from '@/http/requests/reviewOrder'
import loading from '@/mixins/Loading'
import CardHeader from './CardHeader.vue'

export default {
  components: {
    ReviewOrderDonut,
    CardHeader,
  },
  mixins: [loading],
  computed: {
    isLoading() {
      return this.loading.donut
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`review-order-donut-loading`)
      } else {
        this.closeLoading(`review-order-donut-loading`)
      }
    },
  },
  data() {
    return {
      seriesDonut: [],
      loading: {
        donut: false,
      },
      params: {
        client: [],
        status: ['1', '2', '4', '5', '6', '7', '8', '9', '11'],
      },
      idsCharts: {
        status: [],
        clients: [],
        types: [],
      },
    }
  },
  mounted() {
    this.loadReviewOrderDonut()
  },
  methods: {
    loadReviewOrderDonut() {
      this.loading.donut = true
      reviewOrder
        .reviewDonutPlot(this.params)
        .then((res) => {
          let labels = []
          let series = []
          let colors = []
          let donutInfo = res.data.items
          donutInfo.forEach((item, index) => {
            labels[index] = item.label
            series[index] = Number(item.total)
            colors[index] = item.color
            this.idsCharts.status[index] = {
              label: item.label,
              id: item.id,
            }
          })
          ApexCharts.exec(
            'review-order-donut',
            'updateOptions',
            {
              fill: {
                colors: colors,
              },
              legend: {
                markers: {
                  fillColors: colors,
                },
              },
              labels: labels,
              series: series,
            },
            false,
            true
          )
          this.loading.donut = false
        })
        .catch((err) => {
          this.loading.donut = false
          console.log(err)
        })
    },
  },
}
</script>